import React from 'react';
import { ChakraProvider, Box, Flex } from '@chakra-ui/react';
import Settings from '../../components/global/settings'; // Adjust the path as necessary

function checkingAkshay() {
  // Define the name and email here
//   const userName = "Jane Doe"; // Replace with dynamic data as needed
//   const userEmail = "janedoe@example.com"; // Replace with dynamic data as needed

  return (
    <ChakraProvider>
      <Settings />
    </ChakraProvider>
  );
}

export default checkingAkshay;